<mat-card class="mat-elevation-z8">
        <form [formGroup]="vehicle_type_register_form">
          <!-- user details -->
          <div class="form-group">
            <label>Vehicle Type Name  <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='name'>
          </div>
          <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="registerVehicleType()" [disabled]="!vehicle_type_register_form.valid">{{action}}</button>
        </form>
      </mat-card>
